function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import Select from "react-select/creatable";
import adjusters from "../adjusters";

var Step2 = function Step2(props) {
  var claim = props.claim,
      onChangeClaim = props.onChangeClaim;

  var handleAnyInspection = function handleAnyInspection() {
    onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
      any_inspection: !claim.any_inspection
    }));
  };

  var businessOptions = adjusters.map(function (adjuster) {
    return {
      label: adjuster.company,
      value: adjuster.company
    };
  });

  var handleSelectorChange = function handleSelectorChange(item) {
    onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
      business_name: item.value
    }));
  };

  var selectedBusinessName = businessOptions.find(function (adjuster) {
    return adjuster.value === claim.business_name;
  }) || {
    label: claim.business_name,
    value: claim.business_name
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "step"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Raz\xF3n Social"), /*#__PURE__*/React.createElement(Select, {
    options: businessOptions,
    value: selectedBusinessName,
    placeholder: "Tipo de negocio...",
    onChange: handleSelectorChange,
    isClearable: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nombre"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.name,
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        name: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "\xBFHay Inspecci\xF3n?"), /*#__PURE__*/React.createElement("div", {
    className: "checkbox-wrapper-17"
  }, /*#__PURE__*/React.createElement("input", {
    className: "check",
    type: "checkbox",
    id: "switch-17",
    checked: claim.any_inspection,
    onChange: handleAnyInspection
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "switch-17"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Email"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.email,
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        email: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tel\xE9fono"), /*#__PURE__*/React.createElement("input", {
    className: "form-control inputAddress",
    value: claim.phone,
    onChange: function onChange(event) {
      onChangeClaim(_objectSpread(_objectSpread({}, claim), {}, {
        phone: event.target.value
      }));
    }
  }))))));
};

export default Step2;